import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity } from '../../chat-app-context'

export interface AgentIngestAppContextInput {
  /** Job id from the route — present even before the job loads. */
  jobId: string
  /** Uploaded file / display name, once the job row has arrived. */
  fileName?: string
  state?: string
  /** Resolved branch name; falls back to the raw branch id. */
  branchName?: string
  branchId?: string
  /** Selected section id, or null for the "All" tab. */
  selectedSectionId: string | null
  selectedSectionName?: string
}

/**
 * This page is the unstructured agent-ingest run view, so the job kind is
 * fixed. The route only carries `:jobId` and `?section=`; both are enriched
 * here with what the page already has loaded.
 */
export function buildAgentIngestAppContextEntries(
  input: AgentIngestAppContextInput
): AppContextEntry[] {
  const entries: AppContextEntry[] = [
    {
      key: 'Job',
      value: describeEntity({
        name: input.fileName,
        fields: [
          ['kind', 'unstructured'],
          ['state', input.state],
          ['branch', input.branchName ?? input.branchId]
        ],
        id: input.jobId
      })
    }
  ]

  if (input.selectedSectionId === null) {
    entries.push({ key: 'Active section', value: 'All sections' })
  } else {
    entries.push({
      key: 'Active section',
      value: describeEntity({ name: input.selectedSectionName, id: input.selectedSectionId })
    })
  }

  return entries
}
